export const YES_NO = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const MANAGER_TYPES = [
  { value: "operations_manager", label: "Operations Manager" },
  { value: "account_manager", label: "Account Manager" },
  { value: "project_manager", label: "Project Manager" },
  { value: "sales_manager", label: "Sales Manager" },
  { value: "vendor_manager", label: "Vendor Manager" },
  { value: "finance_manager", label: "Finance Manager" },
  { value: "accountant", label: "Accountant" },
  { value: "office_admin", label: "Office Admin" },
  { value: "language_quality_manager", label: "Language Quality Manager" },
  { value: "language_lead", label: "Language Lead" },
];

export const managerTypeLabel = (value) =>
  MANAGER_TYPES.find((m) => m.value === value)?.label ?? null;

// The account's public vendor application form.
export const applicationFormLink = (token) => `${window.location.origin}/apply/vendor/${token}`;

export const VENDOR_PORTAL_EDITORS = ["administrator", "vendor_manager"];